import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { aiSuggestionsByPath } from '@/redux/selectors/aiSelectors.js';
import { memo } from 'react';
import AiSuggestionsPopover from './aiSuggestions/AiSuggestionsPopover.jsx';
import AiSuggestionsTrigger from './AiSuggestionsTrigger.jsx';

const AiInlineSuggestions = ({ path, className }) => {
  const suggestions = useArgSelector(aiSuggestionsByPath, path) || [];

  if (!suggestions || !suggestions?.length) {
    return null;
  }

  return (
    <AiSuggestionsPopover path={path} showDiff={false}>
      <AiSuggestionsTrigger title={`View AI Suggestion`} size={'xs'} hasSuggestions={true} className={className} />
    </AiSuggestionsPopover>
  );
};

export default memo(AiInlineSuggestions);
